import React, { useState } from "react";
import useBackgroundSync from "../hooks/useBackgroundSync";
import LinearProgress from "material-ui/LinearProgress";
import OfflineIcon from "material-ui/svg-icons/device/signal-wifi-off";
import OnlineIcon from "material-ui/svg-icons/device/signal-wifi-3-bar";
import { useBeforeunload } from "react-beforeunload";
import CircularProgress from "material-ui/CircularProgress";
import Dialog from "material-ui/Dialog/Dialog";
import RaisedButton from "material-ui/RaisedButton/RaisedButton";

const itemStyle = {
  margin: "0px 6px"
  // height: 14
};

const iconStyle = {
  width: 16,
  height: 16,
  // marginBottom: -3,
  marginRight: 0
};

// TODO: Add ability to force a save of the entire response

const BackgroundSyncStatusBar = () => {
  const {
    online,
    pendingChanges,
    failedChanges,
    error,
    syncingChanges,
    forceSave,
    forceSaveInProgress,
    forceSaveError,
    shouldDisplayDebugUI,
    setDebugUIVisible
  } = useBackgroundSync();

  const [ saveDialogVisible, setSaveDialogVisible ] = useState(false);

  const hidden = !shouldDisplayDebugUI;

  useBeforeunload(e => {
    if (pendingChanges > 0 || syncingChanges > 0 || failedChanges > 0) {
      e.preventDefault();
      setDebugUIVisible(true);
      return "You'll lose your data!";
    }
  });

  const saveManually = () => {
    forceSave();
    setSaveDialogVisible(true);
  }

  return (
    <div
      style={{
        zIndex: 1000,
        opacity: 0.6,
        fontSize: 12,
        backgroundColor: !online || error ? "#e45f5f" : "white",
        color: online ? "black" : "white",
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100vw",
        alignItems: "center",
        display: hidden ? "none" : "flex",
        padding: "4px 8px",
        height: "auto"
      }}
    >
      {online ? (
        <OnlineIcon style={iconStyle} color="black" />
      ) : (
        <OfflineIcon style={iconStyle} color="yellow" />
      )}
      <span style={{ ...itemStyle }}>{online ? "Online" : "Offline"}</span>
      {syncingChanges === 0 && pendingChanges === 0 && failedChanges === 0 && (
        <>
          <span style={{ marginRight: -4, marginLeft: 4, marginBottom: 1 }}>
            ✓
          </span>
          <span style={{ ...itemStyle }}> All changes saved</span>
        </>
      )}
      {syncingChanges > 0 && (
        <>
          <CircularProgress
            style={{ marginRight: 0, marginLeft: 4, marginBottom: 0 }}
            size={12}
            thickness={2}
            color="black"
          />
          <span style={{ ...itemStyle }}>
            Saving {syncingChanges} change{syncingChanges === 1 ? "" : "s"}
          </span>
        </>
      )}
      {pendingChanges > 0 && (
        <span style={{ ...itemStyle }}>
          {pendingChanges} pending change{pendingChanges === 1 ? "" : "s"}
        </span>
      )}
      <span style={{ ...itemStyle }}>{error}</span>
      <button style={{ ...itemStyle }} onClick={saveManually}>Save Manually</button>
      {!error && !failedChanges && online && (
        <button onClick={() => setDebugUIVisible(false)} style={{ ...itemStyle }}>
          Hide
        </button>
      )}
      {
        saveDialogVisible && <Dialog open={true} title="Saving Fishery" actions={[
          forceSaveError ? <RaisedButton style={{marginRight: 10}} disabled={forceSaveInProgress} onClick={() => forceSave()} label="Try Again" /> : null,
          <RaisedButton disabled={forceSaveInProgress} primary label="Close" onClick={() => setSaveDialogVisible(false)} />,
        ]}>
          { !online && <div style={{marginBottom: 10}}>It appears you are offline. Connect to a network before attempting to save again.</div>}
          { forceSaveInProgress && <LinearProgress /> }
          { forceSaveError && <div style={{marginTop: 10, fontWeight: "bold"}}>{forceSaveError}</div>}
          { !forceSaveError && !forceSaveInProgress && online && "Your fishery has been saved."}
        </Dialog>
      }
    </div>
  );
};

export default BackgroundSyncStatusBar;
